import { render, staticRenderFns } from "./BulkQuote3PList.vue?vue&type=template&id=256c4912"
import script from "./BulkQuote3PList.vue?vue&type=script&lang=js"
export * from "./BulkQuote3PList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports